/*
 * Camada de catálogo: o preço/descrição/imagem/promoção vêm do backend.
 * O front só exibe — nenhum valor é definido aqui.
 *
 * Produtos personalizáveis têm preço único (cada produto = um tamanho já fixo).
 * Produtos não-personalizáveis têm 3 tamanhos com preços diferentes (P/M/G).
 */
export const mapApiProduct = (apiProduct) => {
  const sizes = apiProduct.sizes || [];
  const customizable = apiProduct.is_customizable === true;

  return {
    id: apiProduct.id,
    name: apiProduct.name,
    description: apiProduct.description,
    type: apiProduct.category,
    size: apiProduct.size,
    sizeLabel: apiProduct.size_label || null,
    // Preço direto para produtos personalizáveis (já são por tamanho específico)
    price: parseFloat(apiProduct.initial_price || apiProduct.price || 0),
    // Tamanhos disponíveis apenas para NÃO personalizáveis
    sizes: customizable ? [] : sizes.map(s => ({ ...s, price: parseFloat(s.price) })),
    initial_price: customizable ? null : sizes[0] || null,
    image: apiProduct.image || '',
    available: apiProduct.is_active !== false,
    customizable,
    tags: (apiProduct.tags || []).map((t) => ({
      id: t.id,
      name: t.name,
      slug: t.slug,
    })),
    promotion: apiProduct.promotion
      ? {
          min_quantity: apiProduct.promotion.min_quantity,
          bundle_price: parseFloat(apiProduct.promotion.bundle_price),
          label: apiProduct.promotion.label,
        }
      : null,
    sizePromotions: (apiProduct.size_promotions || []).map((promo) => ({
      label: promo.size_label,
      min_quantity: promo.min_quantity,
      bundle_price: parseFloat(promo.bundle_price),
      text: promo.label,
    })),
  };
};

export const fetchProductsPage = async ({ page = 1, search = '', tag = '' } = {}) => {
  const params = new URLSearchParams({
    ordering: 'customizable_first',
    page: String(page),
  });
  if (search) params.set('search', search);
  if (tag) params.set('tags', tag);

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/api/products/?${params.toString()}`
  );
  if (!response.ok) {
    throw new Error(`Catálogo indisponível (${response.status})`);
  }
  const data = await response.json();
  const isPaginated = !Array.isArray(data);
  const results = isPaginated ? data.results || [] : data;
  const hasMore = isPaginated && Boolean(data.next);

  return {
    products: results
      .filter((product) => product.is_active !== false)
      .map(mapApiProduct),
    count: isPaginated ? data.count || 0 : results.length,
    hasMore,
    nextPage: hasMore ? page + 1 : null,
  };
};

export const fetchProducts = async () => (await fetchProductsPage()).products;
